import React, { useState, useEffect } from "react"
import { useSelector } from "react-redux"
import { Redirect, useHistory, NavLink } from 'react-router-dom'
import {setImage} from '../layout/SetImage'


function Bracket(props) {
  const thisGame = useSelector((state)=>(state.firestore.data.games && state.firestore.data.games[props.match.params.gameId] && state.firestore.data.games[props.match.params.gameId]));
  const restaurants = useSelector((state)=>state.firestore.data.restaurants);
  const userId = useSelector((state)=>state.firebase.auth.uid);
  const currentGames = useSelector((state)=>state.firestore.data.games);
  const history = useHistory();  

  // if the game id doesn't match a game in the firestore database, redirect to createGame
  if(currentGames && !currentGames[props.match.params.gameId]){
    return <Redirect to={'/game/createGame'} />
  }

  if(currentGames === null){
    return <Redirect to={'/game/createGame'} />   
  }

  if (!userId) return <Redirect to='/signin' />

  function displayResults(round){
    let winnersPath = "winnersRound"+round;
    let byePath = 'round'+round+'Bye';

    return(
      <div key={"res"+round}>
        { thisGame && thisGame[winnersPath] &&
          <div>
          <h4 style={{textAlign:"center"}}>{"Round "+round+" Results"}</h4>
          {determineSides(round)}
          { thisGame && thisGame[byePath] &&
            <div>
            <div style={{display:"flex", flexFlow:"row", justifyContent:"space-around"}}>
              {setImage(restaurants[thisGame[byePath][0]]['primaryTag'])}
              <p style={{fontSize:"20px", textAlign:"center"}}>{restaurants[thisGame[byePath]].name}</p>
            </div>
            <p style={{textAlign:"center"}}>advances with a bye</p>
            </div>
          }
          </div>
        }
      </div>
    )    

  }

  function determineSides(round){
    let roundPath = 'round'+round+"Choices";
    let winnersPath = 'winnersRound'+round;
    if(roundPath === 'round1Choices'){
      roundPath = 'roundOneChoices';
    }
    let sortedChoices = Object.entries(thisGame[roundPath]).sort();
    //console.log('sorted');
    //console.log(sortedChoices);
    let returnArray = []

    for(let match in sortedChoices){
      //console.log('match');
      //console.log(match);
      let leftArray = [];
      let rightArray = [];
      for(let player in thisGame.settings.currentPlayers){
        if(sortedChoices[match][1][thisGame.settings.currentPlayers[player]]===sortedChoices[match][1]['choices']['one']){
          leftArray.push(thisGame.settings.currentPlayers[player]);
        }
        else{
          rightArray.push(thisGame.settings.currentPlayers[player]);
        }
      }
      
      returnArray.push(
        <div key={sortedChoices[match][0]}>
        <div style={{display:"flex", flexFlow:"column", justifyContent:"space-around"}} >
          <div style={{display:"flex", flexFlow:"column", padding:"10px"}}>
            <p style={{textAlign:"center", fontSize:"20px"}}>{restaurants[sortedChoices[match][1]['choices']['one']].name}</p>
            <div style={{display:"flex", flexFlow:"row", justifyContent:"left"}}>
            {
              leftArray.map(obj=>{
                return(
                  <div key={obj}>
                    <div className="userButton" style={{padding:"5px"}}><div className="btn btn-floating pink lighten-1">
                      {thisGame.settings.currentNames[obj].substring(0,2)}
                    </div></div>
                  </div>
                )
              })
            }
            </div>
          </div>
          <div style={{display:"flex", flexFlow:"row", padding:"10px", justifyContent:"space-around"}}>
            {setImage(restaurants[sortedChoices[match][1]['choices']['one']]['primaryTag'])}
            <h5 style={{padding:"10px"}}>VS</h5>
            {setImage(restaurants[sortedChoices[match][1]['choices']['two']]['primaryTag'])}
          </div>
          <div style={{display:"flex", flexFlow:"column", padding:"10px"}}>       
            <div style={{display:"flex", flexFlow:"row", justifyContent:"right"}}>
            {
              rightArray.map(obj=>{
                return(
                  <div  key={obj}>
                    <div className="userButton" style={{padding:"5px"}}><div className="btn btn-floating pink lighten-1">
                      {thisGame.settings.currentNames[obj].substring(0,2)}
                    </div></div>       
                  </div>
                )
              })
            }
            </div>
            <p style={{textAlign:"center", fontSize:"20px"}}>{restaurants[sortedChoices[match][1]['choices']['two']].name}</p>
          </div>
        </div>
          {
            leftArray.length === rightArray.length &&
            <p style={{textAlign:"center"}}>decision by coin flip</p>
          }
          {
            leftArray.length !== rightArray.length &&
            <p style={{textAlign:"center"}}>{leftArray.length+" - "+rightArray.length+" decision"}</p>
          }
          <div style={{display:"flex", flexFlow:"row", justifyContent:"space-around"}}> 
            { thisGame && thisGame[winnersPath] &&
              thisGame[winnersPath].includes(sortedChoices[match][1]['choices']['one']) &&
              <div style={{display:"flex", flexFlow:"row", padding:"10px"}}>
                {setImage(restaurants[sortedChoices[match][1]['choices']['one']]['primaryTag'])}
                <p style={{fontSize:"20px"}}>{restaurants[sortedChoices[match][1]['choices']['one']].name + ' wins'} </p> 
              </div>
            }
            { thisGame && thisGame[winnersPath] &&
              thisGame[winnersPath].includes(sortedChoices[match][1]['choices']['two']) &&
              <div style={{display:"flex", flexFlow:"row"}}>
                {setImage(restaurants[sortedChoices[match][1]['choices']['two']]['primaryTag'])}
                <p style={{fontSize:"20px"}}>{restaurants[sortedChoices[match][1]['choices']['two']].name + ' wins'} </p> 
              </div>
            }


          </div>
        <hr/>
        </div>
      )

    }
    return(returnArray)

  }

  //console.log("thisGame");
  //console.log(thisGame);

  let roundTotal = 0;
  for(let obj in thisGame){
    if(obj.includes("winnersRound")){
      roundTotal = roundTotal+1;
    }
  }
  let numArray = [...Array(roundTotal).keys()];
  let resultsArray =[]
  for(let itm in numArray.reverse()){
    resultsArray.push(displayResults(numArray[itm]+1))
  }

  return (
    <>
    <div style={{display:"flex", flexFlow:"row", justifyContent:"center"}}>
      <div style={{display:"flex", flexFlow:"column", maxWidth:'500px'}}>
        {
          <div className="input-field" style={{"display": "flex", "justifyContent": "center"}}>
            <button className="btn pink lighten-1" onClick={()=>{
              history.push("/tournament/"+props.match.params.gameId)
            }}>{"Return to Tournament"}</button>
          </div>
        }
        {resultsArray}
      </div>
    </div>
    </>
  );
}

export default Bracket;